import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AppIcons } from '@core/utilities/icons';

@Component({
  selector: 'app-core-button',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './core-button.component.html',
  styleUrl: './core-button.component.scss'
})
export class CoreButtonComponent {
  readonly icons = AppIcons;
  @Input() label: string = 'Button';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() variant: 'primary' | 'secondary' | 'danger' = 'primary';
  @Input() disabled: boolean = false;
  @Input() fullWidth: boolean = false;
  @Input() isLoading: boolean = false;

  @Output() onClick = new EventEmitter<Event>();

  handleClick(event: Event) {
    if (!this.disabled) {
      this.onClick.emit(event);
    }
  }
}
